<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="primary--text text-center my-5">Invite Friends</h1>
      <v-card>
        <v-tabs background-color="primary" v-model="tab" icons-and-text centered>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#pool">To Pool<v-icon>mdi-pool</v-icon></v-tab>
          <v-tab href="#general">To KewlPewl<v-icon>mdi-account-box</v-icon></v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="pool">
            <v-card flat class="pb-5">
              <div class="mx-15">
                <v-select v-model="poolId" label="Select Pool"
                  :items="ownPools" item-text="poolName" ref="poolId" item-value="poolId">
                </v-select>
                <v-card>
                  <v-list color="white" dense height="200" outlined class="overflow-y-auto">
                    <v-subheader class="my-n5">Select Friends to Invite</v-subheader>
                    <v-list-item class="my-n6" v-for="(item, index) in friends" :key="index" color="primary">
                      <v-checkbox v-model="fList[index]" color="primary"></v-checkbox>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{item.userFName}} {{item.userLName}}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card> 
                <v-text-field label="Enter Friend's Email and press Enter" 
                  v-model="pEmail" append-icon="mdi-plus-thick" type="email"
                  @click:append="addPoolEmail"
                  @keyup.enter="addPoolEmail"
                />
                <v-card class="mb-5">
                  <v-list color="white" dense height="160" outlined class="overflow-y-auto">
                    <v-subheader class="mt-n5">Added Email</v-subheader>
                    <v-list-item class="mt-n4" v-for="(item, index) in pEmailList" :key="index" color="primary">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-icon color="error" @click="delPoolEmail(index)">mdi-close</v-icon>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-row>
                  <v-btn color="error" outlined to="/">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined @click="sendPoolInvite">Invite</v-btn>
                </v-row>
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item value="general">
            <v-card flat class="pb-5">
              <div class="mx-15">
                <v-text-field label="Enter Friend's Email and press Enter" 
                  v-model="gEmail" append-icon="mdi-plus-thick" type="email"
                  @click:append="addGeneralEmail"
                  @keyup.enter="addGeneralEmail"
                />
                <v-card class="mb-5">
                  <v-list color="white" dense height="160" outlined class="overflow-y-auto">
                    <v-subheader class="mt-n5">Added Email</v-subheader>
                    <v-list-item class="mt-n4" v-for="(item, index) in gEmailList" :key="index" color="primary">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-icon color="error" @click="delGeneralEmail(index)">mdi-close</v-icon>
                    </v-list-item>
                  </v-list>
                </v-card>
                <v-row>
                  <v-btn color="error" outlined to="/">Cancel</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined @click="sendGeneralInvite">Invite</v-btn>
                </v-row>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'invite',
  computed: {
    ...mapGetters([
      'friends', 'friendsLoaded', 'ownPools', 'userProfile',
    ]),
  },
  watch: {
    friendsLoaded: function() {
      const len = this.friends.length
      if (len > 0) {
        for (var i=0; i< len; i++) {
          this.fList[i] = false
        }
      }
    },
  },
  created() {
    this.$store.dispatch('getOwnPools')
    this.$store.dispatch('getFriends')
  },
  data: () => ({
    tab: '',
    poolId: '',
    fList: [],
    pEmail: '',
    pEmailList: [],
    gEmail: '',
    gEmailList: [],
  }),
  methods: {
    addPoolEmail() {
      this.pEmail.trim()
      if (this.pEmail != "") {
        var found = this.pEmailList.findIndex(elem => elem == this.pEmail)
        if (found == -1) {
          this.pEmailList.push(this.pEmail)
        }
        this.pEmail = ''
      }
    },
    delPoolEmail(index) {
      this.pEmailList.splice(index, 1)
    },
    sendPoolInvite() {
      if (this.poolId == '') {
        alert('Please select a Pool')
        return;
      }
      const token = this.$store.getters.authToken
      var poolObj = this.ownPools.find(elem => elem.poolId == this.poolId)
      const pName = poolObj.poolName
      const header = { 'Content-type': 'application/json', 'x-auth': token}
      const inviteUser = this.userProfile.userFName + " " + this.userProfile.userLName
      var i=0
      for (i=0; i< this.fList.length; i++) {
        if (this.fList[i] == true) {
          var pUser = {
            poolId: this.poolId,
            userId: this.friends[i]._id,
            userEmail: this.friends[i].userEmail,
            inviteUser: inviteUser,
            poolName: pName
          }
          axios.post('/api/poolInvite', JSON.stringify(pUser), { headers: header})
          .catch(function(err) {
            return alert(err.response.data.err)
          })
        }
      }
      for (i = 0; i< this.pEmailList.length; i++) {
        var email = this.pEmailList[i]
        var iUser = {
          poolId: this.poolId,
          userEmail: email,
          inviteUser: inviteUser,
          poolName: pName
        }
        axios.post('/api/poolInvite', JSON.stringify(iUser), { headers: header })
        .catch(function(err) {
          return alert(err.response.data.err)
        })
      }
      alert("Invites have been sent out")
    },
    addGeneralEmail() {
      this.gEmail.trim()
      if (this.gEmail != "") {
        var found = this.gEmailList.findIndex(elem => elem == this.gEmail)
        if (found == -1) {
          this.gEmailList.push(this.gEmail)
        }
        this.gEmail = ''
      }
    },
    delGeneralEmail(index) {
      this.gEmailList.splice(index, 1)
    },
    sendGeneralInvite() {
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token }
      const inviteUser = this.userProfile.userFName + " " + this.userProfile.userLName
      for (var i=0; i<this.gEmailList.length; i++) {
        var iUser = {
          userEmail: this.gEmailList[i],
          inviteUser: inviteUser
        }
        axios.post('/api/generalInvite', JSON.stringify(iUser), { headers: header })
        .catch(function(err) {
          return alert(err.response.data.err)
        })
      }
    }
  }
}
</script>